import React from "react"

import InputTag from "../../../Input/InputTag"
import FileUploader from "../../../../pages/Projects/features/RaiseTicketForm/common/FileUploader/FileUploader"
import { EFormModule, FormPageProps } from "../.."
import useProjectDetails from "./useProjectDetails"
import MuiAutoComplete from "../../../MuiAutocomplete"
import MuiTextField from "../../../MuiTextField"
import EvInfraProjectDetails from "./EvInfra"

const ProjectDetails = ({ handleNextStep, handleCloseForm, module, redirectPage }: FormPageProps) => {
    const isDemolitionModule = module === EFormModule.DEMOLITION || module === EFormModule.EV_APPLICATION

    const { reasonOptions, formik, dealDoneByUsersOptions, handleAssignToMe, isOutright } = useProjectDetails({
        module: module!,
        handleNextStep,
    })

    if (module === EFormModule.EV_APPLICATION) {
        return (
            <EvInfraProjectDetails
                handleNextStep={handleNextStep}
                handleCloseForm={handleCloseForm}
                module={module}
                redirectPage={redirectPage}
            />
        )
    }

    return (
        <>
            <div className="project_details_container">
                <div className="project_details">
                    <div className="section">
                        <div className="section_header">Project Name*</div>
                        <div>
                            <MuiTextField
                                fullWidth
                                sx={{
                                    height: "32px",
                                }}
                                placeholder="Enter Project Name"
                                value={formik.values.project_name}
                                onChange={e => formik.setFieldValue("project_name", e.target.value)}
                                error={formik.submitCount > 0 && !!formik.errors.project_name}
                            />
                        </div>
                    </div>
                    <div className="d-flex gap-10">
                        <div className="section flex-1">
                            <div className="section_header">
                                Deal Done By <span className="text-sm">(Business POC)*</span>
                            </div>
                            <div>
                                <MuiAutoComplete
                                    sx={{
                                        height: "32px !important",
                                    }}
                                    placeholder="Select Name"
                                    options={dealDoneByUsersOptions || []}
                                    value={formik.values.deal_done_by?.id ? formik.values.deal_done_by : null}
                                    onChange={value => formik.setFieldValue("deal_done_by", value)}
                                    error={formik.submitCount > 0 && !!formik.errors.deal_done_by}
                                />
                                <span
                                    className="color-blue text-xs text-underline pl-4 cursor-pointer"
                                    onClick={handleAssignToMe}>
                                    Assign to me
                                </span>
                            </div>
                        </div>
                        {!isDemolitionModule && (
                            <div className="section flex-1">
                                <div className="section_header">Deal Closure Date*</div>
                                <div>
                                    <InputTag type="date" useCustomDate placeholder="DD/MM/YYYY" />
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="section">
                        <div className="section_header">
                            Project Closure Date <span className="text-sm">(Tentative)*</span>
                        </div>
                        <div>
                            <InputTag
                                type="date"
                                useCustomDate
                                height="32px"
                                placeholder="DD/MM/YYYY"
                                value={formik.values.project_closure_date}
                                onChange={e => formik.setFieldValue("project_closure_date", e.target.value)}
                                error={!!formik.errors.project_closure_date}
                                showError={formik.submitCount > 0}
                            />
                        </div>
                    </div>
                    <div className="section">
                        {isDemolitionModule && (
                            <>
                                <div className="section_header">Upload Deal Docs</div>
                                <div>
                                    <FileUploader
                                        name="deal_docs"
                                        size="md"
                                        onChange={val => formik.setFieldValue("deal_docs", val)}
                                        title="Upload File"
                                        uploadedCount={formik.values.deal_docs?.length}
                                        total={3}
                                        error={!!formik.errors.deal_docs}
                                        showError={formik.submitCount > 0}
                                        multiple
                                    />
                                </div>
                            </>
                        )}
                    </div>
                    {!isDemolitionModule ? (
                        <>
                            <div className="section">
                                <div className="section_header">Upload Cancelled Cheque*</div>
                                <div>
                                    <FileUploader
                                        name="cancelled_cheque"
                                        size="lg"
                                        onChange={e => {}}
                                        title="Upload File"
                                        total={1}
                                    />
                                </div>
                            </div>
                            <div className="section">
                                <div className="section_header">Upload Owner and Company Relationship Document*</div>
                                <div>
                                    <FileUploader
                                        name="owner_and_company_relationship_document"
                                        size="lg"
                                        onChange={e => {}}
                                        title="Upload File"
                                        total={1}
                                    />
                                </div>
                            </div>
                            <div className="section">
                                <div className="section_header">Upload Agreement Document*</div>
                                <div>
                                    <FileUploader
                                        name="agreement_document"
                                        size="lg"
                                        onChange={e => {}}
                                        title="Upload File"
                                        total={1}
                                    />
                                </div>
                            </div>
                            <div className="section">
                                <div className="section_header">Upload Deal Docs</div>
                                <div>
                                    <FileUploader
                                        name="deal_docs"
                                        size="lg"
                                        onChange={e => {}}
                                        title="Upload File"
                                        total={1}
                                    />
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            {isOutright && (
                                <div className="section">
                                    <div className="section_header">Purchase Order*</div>
                                    <div>
                                        <FileUploader
                                            name="purchase_order"
                                            size="md"
                                            onChange={val => formik.setFieldValue("purchase_order", val)}
                                            title="Upload File"
                                            uploadedCount={formik.values.purchase_order?.length}
                                            total={1}
                                            error={!!formik.errors.purchase_order}
                                            showError={formik.submitCount > 0}
                                        />
                                    </div>
                                </div>
                            )}

                            <div className="section">
                                <div className="section_header">Reason*</div>
                                <div>
                                    <MuiAutoComplete
                                        sx={{
                                            height: "32px !important",
                                        }}
                                        placeholder="Select Reason"
                                        options={reasonOptions || []}
                                        value={formik.values.reason?.id ? formik.values.reason : null}
                                        onChange={value => formik.setFieldValue("reason", value)}
                                        error={formik.submitCount > 0 && !!formik.errors.reason}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
            <footer className="raise-ticket-form__footer">
                <button className="raise-ticket-form__footer-button cancel-btn" onClick={handleCloseForm}>
                    Cancel
                </button>
                <button className="raise-ticket-form__footer-button next-btn" onClick={() => formik.handleSubmit()}>
                    Next
                </button>
            </footer>
        </>
    )
}

export default ProjectDetails
